import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../components/ReusableComponents/Axios";
import "./Assessts/Styles/PTResults.scss";
import { GoTrophy } from "react-icons/go";
import { FaBullseye } from "react-icons/fa6";
import { IoMdTime } from "react-icons/io";
const Practiceresults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const totalMinutes = Math.floor((new Date() - new Date(localStorage.getItem("ExamStartTime"))) / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const formattedTime = <> {hours.toString().padStart(2, "0")} <span style={{ fontSize: "10px" }}>hh</span>
        : {minutes.toString().padStart(2, "0")} <span style={{ fontSize: "10px" }}>mm</span>
    </>

    const scorecolor = (e) => {
        switch (true) {
            case e <= 30:
                return "Work Hard";
            case e >= 31 && e <= 50:
                return "Nice Work";
            case e >= 51 && e <= 80:
                return "Awesome";
            case e > 80:
                return "Out Standing";
            default:
                return "";
        }
    };
    return (

        <div className="dflex alignitems flexd-column">
            <span className="CPointer mb-3 dflex alignitems JCCenter mt-3" style={{ color: "blue", textDecoration: "underline" }}
                onClick={() => navigate("/PracticeTest/TestSelection", { replace: true })}> Click here to take another test  </span>
            <div className="Card p-4 m-4 PTResults dflex JSBetween flexd-column alignitems">
                <div className="dflex Percentage-CAssessment gap-3">
                    <div>
                        <GoTrophy />
                    </div>
                    <div className="dflex flexd-column ">
                        <span> {(location.state?.CQuestions / location.state?.TQuestions) * 100}%</span>
                        <span>{scorecolor((location.state?.CQuestions / location.state?.TQuestions) * 100)}!</span>
                    </div></div>
                <hr className="w-100" />
                {/* <div className="dflex  PTCorrect gap-4 alignitems Resultsgrid">
                    <FaBullseye /> <span> Correct</span> <span>{location.state?.CQuestions}</span>  </div>

                <div className="dflex  PTInCorrect gap-4 alignitems Resultsgrid">
                    <FaBullseye /> <span>In Correct</span> <span>{location.state?.IQuestions}</span>  </div>

                <div className="dflex PTTimeTaken gap-4 alignitems Resultsgrid"><IoMdTime /> <span>Time Taken</span> <span>{formattedTime}</span> </div> */}

                <div>
                    <div className="PTCorrect Resultsgrid"><span> <FaBullseye />  Total Questions</span> <span>: {location.state?.TQuestions}</span>  </div>
                    <div className="PTCorrect Resultsgrid"><span> <FaBullseye />  Correct</span> <span>: {location.state?.CQuestions}</span>  </div>
                    <div className="PTInCorrect Resultsgrid mt-2">  <span> <FaBullseye /> In Correct</span> <span>: {location.state?.IQuestions}</span>  </div>
                    <div className="PTInCorrect Resultsgrid mt-2">  <span> <FaBullseye /> UnAttempted</span> <span>: {location.state?.UnAttempted}</span>  </div>
                    <div className="PTTimeTaken Resultsgrid mt-2"> <span><IoMdTime /> Time Taken</span> <span>: {formattedTime}</span> </div>
                </div>
            </div>
        </div>
    );
};
export default Practiceresults;